// import MoneyOffCsredOutlinedIcon from '@mui/icons-material/MoneyOffCsredOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined"

const ManagerZoneMenu = {
    id: 'managerZoneRoot',
    title: 'OWNER DASHBOARD',
    type: 'group',
    children: [
        // {
        //     id: 'expenses',
        //     title: 'Expense',
        //     type: 'item',
        //     url: '/expenses',
        //     icon: MoneyOffCsredOutlinedIcon,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'sales',
        //     title: 'Recent sales',
        //     type: 'item',
        //     url: '/sales',
        //     icon: PaymentsOutlinedIcon,
        //     breadcrumbs: false
        // },
        {
            id: 'dailyreport',
            title: 'Daily Report',
            type: 'item',
            url: '/dailyreport',
            icon: PaymentsOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'ownerGrowthEngine',
            title: 'Client Growth Engine',
            type: 'item',
            url: '/ownerGrowthEngine',
            icon: BarChartOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'staffDailyReport',
            title: 'Daily Report By Staff',
            type: 'item',
            url: '/staffDailyReport',
            icon: PaymentsOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'ownerCashFlow',
            title: 'Cash Flow Dashboard',
            type: 'collapse',
            icon: BarChartOutlinedIcon,
            children: [
                {
                    id: 'revenue',
                    title: 'Cash Received',
                    type: 'item',
                    url: '/revenue',
                    icon: BarChartOutlinedIcon,
                    breadcrumbs: false
                },
                {
                    id: 'fixedExpense',
                    title: 'Fixed Operating Expenses',
                    type: 'item',
                    url: '/fixedExpense',
                    icon: BarChartOutlinedIcon,
                    breadcrumbs: false
                },
                {
                    id: 'variableExpense',
                    title: 'Direct Cost',
                    type: 'item',
                    url: '/variableExpense',
                    icon: BarChartOutlinedIcon,
                    breadcrumbs: false
                },
                {
                    id: 'monthlySummary',
                    title: 'Cash Flow Summary',
                    type: 'item',
                    url: '/monthlySummary',
                    icon: BarChartOutlinedIcon,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'ownerInventory',
            title: 'Inventory',
            type: 'collapse',
            icon: ShoppingCartOutlinedIcon,
            children: [
                {
                    id: 'lowStockList',
                    title: 'Low Stock List',
                    type: 'item',
                    url: '/lowStockList',
                    icon: ShoppingCartOutlinedIcon,
                    breadcrumbs: false
                },
                {
                    id: 'inventoryBarChart',
                    title: 'Inventory Chart',
                    type: 'item',
                    url: '/inventory/barchart',
                    icon: ShoppingCartOutlinedIcon,
                    breadcrumbs: false
                }
            ]
        }
        // {
        //     id: 'revenueSummary',
        //     title: 'Revenue Summary',
        //     type: 'item',
        //     url: 'revenueSummary',
        //     icon: BarChartOutlinedIcon,
        //     breadcrumbs: false
        // }
    ]
}
export default ManagerZoneMenu
